import getInstance from 'app/games/whoisit/selectors/getInstance';

export default function getInstanceRemainingCardsCount(state, instanceId) {
  return getInstance(state, instanceId)?.remainingCardsCount;
}
